import React from 'react';
import { Images } from '../../assets';
import { Footer, Header } from '../../components';
import styles from './style.module.scss';

const IMG_LIST_1 = [
  Images.about_1_1,
  Images.about_1_2,
  Images.about_1_3,
  Images.about_1_4,
  Images.about_1_5,
  Images.about_1_6
];
const IMG_LIST_2 = [
  Images.about_2_1,
  Images.about_2_2,
  Images.about_2_3,
  Images.about_2_4,
  Images.about_2_5,
  Images.about_2_6
];

export default function Page() {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <div className={[styles.section, styles.section1].join(' ')}>
          <div className={styles.row}>
            <div className={styles.title}>ABOUT</div>
            <div className={styles.desc}>
              <div className={styles.kr}>
                레지던스 오후는 20~30대 여성을 위해 설계된 여성 전용 프리미엄
                레지던스입니다.
                {'\n'}
                호텔 감성의 인테리어, 풀옵션 완비, 강력한 보안 객실을 갖추어
                안전하고 편안하며 스타일리시한 주거 환경을 제공합니다.
                {'\n'}
                홍대 중심에 위치해 학생, 직장인, 외국인 입주자 모두에게 편리함과
                쾌적함을 동시에 제공하는 최적의 공간입니다.
              </div>
              <div className={styles.en}>
                Residence OHU is a premium, women-only residence designed for
                women in their 20s and 30s.
                {'\n'}
                With enhanced security, hotel-style interiors, and
                fully-equipped rooms, we offer a safe and stylish living
                environment.
                {'\n'}
                Located in the heart of Hongdae, it is the perfect space for
                students, professionals, and international residents.
              </div>
            </div>
          </div>
        </div>
        <div className={[styles.section, styles.section2].join(' ')}>
          <div className={styles.row}>
            <div className={styles.title}>FACILITIES</div>
            <div className={styles.desc}>
              <div className={styles.kr}>
                각 층별 공용주방을 통해 보다 편리한 생활을 누릴 수 있습니다.
                {'\n'}
                공용주방에는 인덕션, 전기밥솥, 토스터 등 기본 설비와 조리 도구가
                준비되어 있어 간단한 식사부터 일상적인 요리도 가능합니다.
                {'\n'}
                또한 캡슐 커피 머신이 설치되어 있어 하루의 시작과 휴식 시간에
                여유로운 커피 한 잔을 즐길 수 있습니다.
              </div>
              <div className={styles.en}>
                Residence OHU provies a shared kitchen on every floor for
                convenient daily living.
                {'\n'}
                Each kitchen features an induction cooktop, rice cooker,
                toaster, and essentials for easy everyday cooking.
                {'\n'}A capsule coffee machine is also available, allowing
                residents to enjoy a relaxing cup of coffee at any time.
              </div>
            </div>
          </div>
          <div className={styles.imgContainer}>
            {IMG_LIST_1.map((item, index) => (
              <img
                src={item}
                alt={`ohu-about-image-${index}`}
                className={styles.img}
              />
            ))}
          </div>
        </div>
        <div className={[styles.section, styles.section3].join(' ')}>
          <div className={styles.row}>
            <div className={styles.title}>SECURITY</div>
            <div className={styles.desc}>
              <div className={styles.kr}>
                출입구, 층별, 객실로 이어지는 3중 보안 시스템과 ADT캡스의 24시간
                보안관리, 사각지대를 최소화한 CCTV 보안으로 하루의 시작과 끝까지
                안심할 수 있는 환경을 제공합니다.
              </div>
              <div className={styles.en}>
                A triple security system covering the entrance, each floor, and
                individual rooms, 24-hours ADT CAPS professional security, and
                stategically placed CCTV monitoring ensure a secure living
                environment at all times.
              </div>
            </div>
          </div>
          <div className={styles.imgContainer}>
            {IMG_LIST_2.map((item, index) => (
              <img
                src={item}
                alt={`ohu-about-image-${index}`}
                className={styles.img}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
